// src/pages/exercise/ExercisePage.jsx
import React, { useEffect, useState, useCallback, useRef } from 'react';
import Scene3D from './components';
import { useStore } from './components/Stores/exerciseStore';
import { RerollCounter } from './components/UI/ExerciseSuggestionPanel';
import { ExerciseSuggestionPanel } from './components/UI/ExerciseSuggestionPanel';
import { ExerciseTimerPanel } from './components/UI/ExerciseTimerPanel';
import { ConfettiCanvas } from './components/UI/ConfettiCanvas';
import { ExerciseCompletePopup } from './components/UI/ExerciseCompletePopup';
import ExerciseLoader from './components/UI/ExerciseLoader'; // ← new


const ExercisePage = () => {
  const phase             = useStore((s) => s.phase);
  const completedMissions = useStore((s) => s.completedMissions);
  const missionPool       = useStore((s) => s.missionPool);

  const [largeTrigger, setLargeTrigger]     = useState(0);
  const [showPopup, setShowPopup]           = useState(false);
  const [smallTrigger, setSmallTrigger]     = useState(0);
  const [confettiOrigin, setConfettiOrigin] = useState({ x: 0, y: 0 });

  const prevCompletedCount = useRef(0);
  const allDoneFired       = useRef(false);

  // Watch completedMissions for small confetti on each new completion
  useEffect(() => {
    const newCount = completedMissions.length;
    if (newCount > prevCompletedCount.current) {
      setConfettiOrigin({
        x: window.innerWidth * 0.15,
        y: window.innerHeight * 0.5,
      });
      setSmallTrigger((t) => t + 1);
      prevCompletedCount.current = newCount;
    }
  }, [completedMissions]);

  // Reset tracking when leaving EXERCISE phase
  useEffect(() => {
    if (phase === 'SELECTION') {
      prevCompletedCount.current = 0;
      allDoneFired.current       = false;
    }
  }, [phase]);

  const handleAllDone = useCallback(() => {
    if (allDoneFired.current) return;
    allDoneFired.current = true;
    setTimeout(() => {
      setLargeTrigger((t) => t + 1);
      setShowPopup(true);
    }, 400);
  }, []);

  const handleClosePopup = useCallback(() => {
    setShowPopup(false);
  }, []);

  useEffect(() => {
    const handleWheel = (e) => {
      const { phase: p, scrollLocked, triggerTransition1, triggerTransition2 } =
        useStore.getState();
      if (scrollLocked) { e.preventDefault(); return; }
      if (e.deltaY > 0 && p === 'SELECTION') { e.preventDefault(); triggerTransition1(); }
      else if (e.deltaY < 0 && p === 'EXERCISE') { e.preventDefault(); triggerTransition2(); }
    };
    window.addEventListener('wheel', handleWheel, { passive: false });
    return () => window.removeEventListener('wheel', handleWheel);
  }, []);

  return (
    <div style={{
      position: 'relative',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #64c4e1 0%, #d2a1e3 100%)',
    }}>
      <ExerciseLoader />  {/* ← new: self-dismisses after 3s, z-index 9999 */}

      <Scene3D />

      {phase === 'EXERCISE' && (
        <>
          <ExerciseTimerPanel /> {/* Removed duplicated ExerciseSuggestionPanel */}
        </>
      )}

      {/* Small confetti — per card completion */}
      <ConfettiCanvas
        trigger={smallTrigger}
        intensity="small"
        origin={confettiOrigin}
      />

      {/* Large confetti — all done */}
      <ConfettiCanvas
        trigger={largeTrigger}
        intensity="large"
      />

      {/* Dramatic all-done popup */}
      {showPopup && (
        <ExerciseCompletePopup onClose={handleClosePopup} />
      )}

      <div style={{ height: '200vh', position: 'relative', pointerEvents: 'none' }} />
    </div>
  );
};

export default ExercisePage;